export default __webpack_public_path__ + "static/InterDisplay-MediumItalic-6c6c80a27700d5ab6fad917e73529021.woff2";